package com.solevo.dist.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.solevo.dist.components.DashboardPageLayout
import com.solevo.dist.components.RequireAuth
import com.solevo.dist.i18n.LocalStrings
import com.solevo.dist.i18n.Localization
import com.solevo.dist.theme.styles.sectionTitle
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Iframe

private const val DEFAULT_LANGUAGE = "en"
private val SUPPORTED_LANGUAGES = listOf("en", "fr", "pt")

@Page("/terms-and-privacy")
@Composable
fun TermsAndPrivacyScreen() {
    RequireAuth { TermsAndPrivacyPage() }
}

@Composable
private fun TermsAndPrivacyPage() {
    val language by Localization.language.collectAsState()
    val strings = LocalStrings.current

    // DashboardPageLayout already renders its own DashboardHeader; passing another via `header`
    // would draw a second notification-bell row (matches how SettingsPage calls it).
    DashboardPageLayout {
        Column(Modifier.fillMaxSize().padding(24.px)) {
            SpanText(strings.labelTermsAndPrivacy, Modifier.sectionTitle())
            // The bundled file is a standalone document with its own styling, so it renders in an
            // iframe to keep those rules from leaking into the rest of the app.
            Iframe(
                attrs = Modifier
                    .fillMaxWidth()
                    .flexGrow(1f)
                    .margin(top = 16.px)
                    .backgroundColor(rgb(255, 255, 255))
                    .border(1.px, LineStyle.Solid, rgb(232, 235, 240))
                    .borderRadius(12.px)
                    .toAttrs {
                        attr("src", termsUrlFor(language))
                        attr("title", strings.labelTermsAndPrivacy)
                    }
            )
        }
    }
}

private fun termsUrlFor(language: String): String {
    val iso = language.substringBefore("-").substringBefore("_").lowercase()
        .let { if (it in SUPPORTED_LANGUAGES) it else DEFAULT_LANGUAGE }
    return "/terms/loyalty_terms_$iso.html"
}
